import {WithLocale} from './request.types';

export enum IFieldSourceType {
  DYNAMIC = 'DYNAMIC',
  STATIC = 'STATIC',
  DYNAMIC_LIST = 'DYNAMIC_LIST'
}
export enum ContractTypes {
  outbox = 'initiator',
  inbox = 'party'
}
export enum ContractStates {
  ALL = 'ALL',
  DRAFT = 'DRAFT',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
  INBOX = 'IN_PROGRESS,SUCCESS,FAILED',
  VERIFICATION = 'VERIFICATION',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
  WAITING_FOR_CONFIRMATION = 'WAITING_FOR_CONFIRMATION',
  DONE = 'DONE'
}
export enum UserStatuses {
  SIGNED = 'USER_SIGNED',
  NOT_SIGNED = 'USER_NOT_SIGNED',
  REJECTED = 'USER_REJECTED'
}

export const InboxStates = [
  {state: ContractStates.ALL},
  {state: ContractStates.IN_PROGRESS},
  {state: ContractStates.FAILED},
  {state: ContractStates.SUCCESS},
];

export const OutboxStates = [
  {state: ContractStates.ALL},
  {state: ContractStates.DRAFT},
  {state: ContractStates.IN_PROGRESS},
  {state: ContractStates.CANCELED},
  {state: ContractStates.SUCCESS},
];

export const ContractStatesList = {
  [ContractTypes.inbox]: InboxStates,
  [ContractTypes.outbox]: OutboxStates,
};
export enum RequestTypes {
  outbox = 'outbox',
  inbox = 'inbox'
}
export interface IDocument {
  templateId: string;
  title: WithLocale;
  description: WithLocale;
  createdDate: string;
  currentState: string;
  documentId: string;
  fields: IField[];
  loading?: boolean;
  readOnly: boolean;
  // Заведён в document-core с тарника doctype1 — связывает документ с
  // комплектом конструктора (см. КОНСТРУКТОР_РЕСТЫ.md, раздел 0). Не
  // приходит для документов вне конструктора.
  docType?: string;
}
export interface IDocumentTemplateLocalized {
  title: string;
  locale: string;
  description: string;
  body: string;
}
export interface IDocumentTemplate {
  templateId: string;
  createdDate: string;
  localizedTemplates: { [locale: string]: IDocumentTemplateLocalized };
  currentState: string;
}
export interface IContract {
  contractId: string;
  canArchive: boolean;
  documentId: string;
  createdDate: Date;
  canCancel: boolean;
  confirmedParties: any[];
  documentTitle: WithLocale;
  initiator: IIN;
  initiatorCanSign: boolean;
  initiatorFullName: IFullName;
  initiatorSignatureProvided: boolean;
  fields: IField[]; // TODO: typify
  language: string;
  lastActionApproved: boolean;
  parties: IIN[];
  partiesCanSign: boolean;
  partiesFullNames: IParty[];
  extras?: any;
  isRead?: boolean;
  readByParties: any; // TODO: typify
  rejectedParties: IRejectedParty[];
  readOnly: boolean;
  state?: ContractStates;
  documentStructure?: string;
  // Есть только у договоров из загруженного пользователем PDF (без шаблона,
  // см. UploadContractComponent) — по нему ContractItemComponent показывает
  // сам файл вместо полей формы.
  uploadedFile?: IUploadedFile;

  // actionLog: [{action: "CREATED", timestamp: "2019-10-15T10:15:27Z"}]
}
export interface IUploadedFile {
  title: string;
  fileName: string;
  size: number;
  pages?: number;
  sha256: string;
}
export interface IRejectedParty {
  party: IIN;
  reason: string;
}
export interface IParty {
  [iin: string]: IFullName;
}
export interface IIN {
  iin: string;
}
export interface IFullName {
  first: string;
  last: string;
  middle: string;
}
export enum ILocale {
  kk = 'kk',
  ru = 'ru',
  en = 'en'
}
// Вариант RADIO-поля БЕЗ справочника — заводится целиком в админке (см.
// tiny-editor.component.ts, поле "Варианты ответа") и живёт внутри самого
// field.options JSON, а не в отдельной сущности "справочник". text —
// опционален: если задан, при выборе этого варианта его ru/kk-текст пишется
// в fieldsValue/localizedFieldsValue под кодом "<code>__text" (см.
// syncDependentFields в form.component.ts) — ТОЛЬКО если поле с таким кодом
// реально заведено в шаблоне (тот же opt-in принцип, что у
// ORG_FOUNDERS_TEXT_SUFFIX/JUR_ADDRESS_FULL_SUFFIX). text может содержать
// {{другойКодПоля}} — резолвится позже в fillTemplateBody (multi-pass).
export interface IFieldOption {
  value: string;
  label: WithLocale;
  text?: WithLocale;
}
export interface IField {
  additional: string;
  code: string;
  dataType: 'STRING' | any; // TODO: typify
  defaultValue: string;
  display: boolean;
  errorMessage: WithLocale;
  hint: WithLocale;
  mandatory: boolean;
  multiChoice: boolean;
  order: number;
  groupCode: string;
  groupOrder: number;
  dynamic: boolean;
  // Надпись кнопки добавления копии динамической группы (задаётся в админке
  // у её поля); пусто — общий перевод 'duplicate' ("Добавить этап").
  addButtonTitle?: WithLocale;
  placeHolder: WithLocale;
  readOnly: boolean;
  title: WithLocale;
  validator: string;
  sourceType?: string;
  source?: string;
  subGroupCode?: string;
  targetFields?: string[];
  dateGreaterThan?: string;
  dateLessThan?: string;
  maxDate?: any;// TODO: typify DateStruct
  minDate?: any;// TODO: typify DateStruct
  length?: string;
  groupTitleKz?: string;
  groupTitleEn?: string;
  groupTitleRu?: string;
  loading?: boolean;
  duplicated?: boolean;
  duplicatedGroup?: boolean;
  isMultiCurrencyHide?: boolean;
  // RADIO без справочника — варианты вводятся в админке вручную (см.
  // IFieldOption). Если задан, поле рендерится через app-radio-group
  // напрямую из options, минуя staticSources/справочник (см.
  // isManualOptionsField в form.component.ts).
  options?: IFieldOption[];
  // Текст в документ для STRING/TEXTAREA — заводится в админке (аналог
  // IFieldOption.text у RADIO). Если задан и поле заполнено, {{code}} в
  // документе резолвится в этот текст, где {{value}} заменяется введённым
  // значением; пустое поле — в документ ничего не попадает (см.
  // resolveFieldDocText в pdf-template.util.ts).
  text?: WithLocale;
  // Условная видимость поля — конфигурируется в админке, без хардкода в
  // проекте (см. isFieldVisible в form.component.ts): поле видно, только
  // если fieldsValue[showIfField] совпадает с одним из значений showIfValue
  // (через запятую). Пусто/не задано — поле видно как раньше (только по
  // display).
  showIfField?: string;
  showIfValue?: string;
  // Автозаполнение из реста — конфигурируется в админке, без привязки к
  // коду поля (см. autofill.util.ts).
  autofill?: IFieldAutofill;
}

export interface IFieldAutofill {
  // Относительный путь реста своего API, напр. "/constructor/founders".
  url: string;
  // Откуда в ответе взять значение (синтаксис — см. autofill.util.ts); там
  // же, в самом path, таблица замены ("=> fiz=1, *=2") и признак "не
  // перезаписывать заполненное" ("?" в начале).
  path: string;
  // Ключ из AUTOFILL_FORMATS.
  format?: string;
  // То же, что "=>" и "?" в path, отдельными свойствами. Бэк их сейчас не
  // хранит (см. autofill.util.ts) — читаются на случай, если начнёт.
  map?: string;
  onlyIfEmpty?: boolean;
}
export interface IValidation {
  [fieldCode: string]: {
    isValid?: boolean;
    startValidation: boolean;
    dynamicValid?: boolean;
    showAgreementLink?: boolean;
    myIin?:boolean;
  };
}
export interface IGroupedItems {
  groupTitleRu: string;
  groupTitleKz: string;
  groupTitleEn: string;
  groupCode: string;
  groupOrder: number;
  items: ISubGroup[];
}
export interface IGroupedItemsWithoutSub {
  groupTitleRu: string;
  groupTitleKz: string;
  groupTitleEn: string;
  groupCode: string;
  items: IField[];
}
export interface ISubGroup {
  subGroupCode: string;
  fields: IField[];
}
export interface IFieldValue {
  [fieldCode: string]: string;
}
